<template>
    <v-container fluid grid-list-md style="width: 95%;" class="availability-coverage-report">
        <h1>Availability Coverage Report</h1>

        <div>
            <p>
                % represents the percentage of days that are unavailable.
            </p>
        </div>
        
        <!-- pagination -->
        <div>
            <v-btn @click="handlePageChange(-1)" :disabled="!multiplePages">
                < Previous
            </v-btn>
            <v-btn @click="handlePageChange(1)" :disabled="!multiplePages"> 
                Next > 
            </v-btn>
            <v-icon v-if="pageLoading" class="spin">sync</v-icon>

        </div>

        <!-- search -->
        <div style="width: 300px;">
            <v-text-field
                v-model="searchText"
                append-icon="search"
                label="Search"
                single-line
                hide-details
                @keyup.enter="loadData()"
            ></v-text-field>
        </div>

        <table>
            <tr>
                <th class="first-col" @click="handleSortByColumn('hotel_code')"><button>Hotel</button></th>
                <template v-for="month in months">
                    <th @click="handleSortByColumn(month)">
                        <button>{{ month }} 
                            <v-icon v-if="sortColumn == month && sortDirection == 'asc' && !sortLoading">keyboard_arrow_up</v-icon>
                            <v-icon v-if="sortColumn == month && sortDirection == 'desc' && !sortLoading">keyboard_arrow_down</v-icon>
                            <v-icon v-if="sortColumn == month && sortLoading" class="spin">sync</v-icon>
                        </button>
                    </th>
                </template>    
            </tr>

            <template v-if="hotelResults" v-for="hotel in hotelResults">
                <tr 
                    @click="handleRowClick(hotel.hotel_key)"
                    v-bind:class="{
                    'greyed-out': selectedHotelKey != hotel.hotel_key && roomView,
                    'selected': selectedHotelKey == hotel.hotel_key && roomView
                }">

                    <td class="first-col"> {{ hotel.hotel_code }} - {{ hotel.hotel_name }}</td>
                    <template v-for="month in months">

                        <td>{{ getMonthMissingPercentage(month, hotel) }}%</td>

                    </template>
                </tr>

                <tr v-if="selectedHotelKey == hotel.hotel_key && roomView" v-for="room in roomResults">
                    <td>{{ room.name }}</td>
                     <template v-for="month in months">
                        <td>{{ getMonthMissingPercentage(month, room) }}%</td>
                    </template>
                </tr>
            
            </template>


        </table>

    </v-container>
</template>

<script>
/**
* 
*
*/
import axios from 'axios';

export default {
    name: 'availability-coverage-report',
    props: [],
    data () {        
        return {
            searchText: '',
            sortColumn: '',
            sortDirection: '',
            page: 1,
            hotelResults: [],
            roomView: false,
            roomResults: [],
            selectedHotelKey: null,
            sortLoading: false,
            pageLoading: false,
            multiplePages: false,
            months: []
        }
    },

    methods: {
        loadData: function(){

            let params = { 'searchText': this.searchText, 'sortColumn': this.sortColumn, 'sortDirection': this.sortDirection, 'page': this.page };
            
            axios.get('/api/availability-coverage-report', {'params': params } )
                .then(function(response){
                    this.hotelResults = response.data.paginatedResults.data;
                    this.months = response.data.months;
                    this.multiplePages = response.data.paginatedResults.next_page_url !== null;
                }.bind(this))

                .catch(function (error) {
                    console.log(error);
                })

                .finally(function (res) {
                    this.sortLoading = false;
                    this.pageLoading = false;
                }.bind(this));
        },

        loadRoomData: function(hotelKey){
            let params = { 'hotelKey': hotelKey };

            axios.get('/api/availability-coverage-report/rooms', {'params': params})
                .then(function(response){
                    this.roomResults = response.data;
                }.bind(this));
        },

        handlePageChange(diff) {
            this.roomView = false;
            
            if (this.page + diff > 0) {
                this.page += diff;
                this.pageLoading = true;
                console.log(this.pageLoading);
                this.loadData();
            }            
        },

        handleRowClick(hotelKey) {
            this.toggleRoomView();

            if (!this.roomView) {
                this.roomResults = [];
                return
            }
            this.loadRoomData(hotelKey);

            this.selectedHotelKey = hotelKey;
            
        },

        toggleRoomView() {
            this.roomView = !this.roomView;
        },

        handleSortByColumn(column) {
            if (this.sortColumn == column) {
                this.sortDirection = this.sortDirection == 'asc' ? 'desc' : 'asc';
            } else {
                this.sortColumn = column;
                this.sortDirection = 'asc';
            }

            this.sortLoading = true;


            this.loadData();
        },

        getMonthMissingPercentage(month, arr){
            let colName = month + '_days_missing_percentage';
            console.log(colName);
            return arr[colName];
        }

    },

    mounted() {
        this.loadData();
    },

    computed: {

    },

    watch: 
    {
  
    }
}
</script>

<style>
    .availability-coverage-report table {
        width: 100%;
        border: 1px solid black;
        border-collapse: collapse;
    }

    .availability-coverage-report table th {
        font-size: larger;
        text-align: center;
        border: 1px solid black;
        background-color:lightgrey;
    }
    
    .availability-coverage-report table .first-col {
        text-align: left;
        width: 50%;
    }
    
    .availability-coverage-report table th button {
        width: 100%;
        text-transform: capitalize;
    }

    .availability-coverage-report table td {
        text-align: center;
        border: 1px solid black;
        padding: 5px;
    }

    .availability-coverage-report table .greyed-out {
        background-color: lightgray;
        opacity: .5;
    }

    .availability-coverage-report table .selected {
        font-weight: bold;
        border: 2px solid black;
    }
</style>
